"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var core_1 = require("@material-ui/core");
var styles = function (theme) {
    return styles_1.createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        }
    });
};
var DialogTitle = styles_1.withStyles(styles)(function (props) {
    var children = props.children, classes = props.classes, onClose = props.onClose, other = __rest(props, ["children", "classes", "onClose"]);
    return (react_1.default.createElement(DialogTitle_1.default, __assign({ disableTypography: true, className: classes.root }, other),
        react_1.default.createElement(Typography_1.default, { variant: "h6" }, children),
        onClose ? (react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: classes.closeButton, onClick: onClose },
            react_1.default.createElement(Close_1.default, null))) : null));
});
var DialogContent = styles_1.withStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(2)
    },
}); })(DialogContent_1.default);
var DialogActions = styles_1.withStyles(function (theme) { return ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}); })(DialogActions_1.default);
var Table = styles_1.withStyles(function (theme) { return ({
    root: {
    // width:500
    // minWidth:'50%'
    },
}); })(Table_1.default);
var TableCell = styles_1.withStyles(function (theme) { return ({
    root: {
        borderBottom: "none",
    },
}); })(TableCell_1.default);
var ProductDetail = function (props) {
    return (react_1.default.createElement(react_1.default.Fragment, null, (function () {
        switch (props.type) {
            case 1:
            case 2:
            case 3:
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(Dialog_1.default, { onClose: props.onClose, "aria-labelledby": "customized-dialog-title", open: props.open },
                        react_1.default.createElement(DialogTitle, { id: "customized-dialog-title", onClose: props.onClose }, props.info.title),
                        react_1.default.createElement(DialogContent, { dividers: true },
                            react_1.default.createElement(Table, null,
                                react_1.default.createElement(core_1.TableBody, null, Object.keys(props.info).map(function (key, index) {
                                    if (key != "title" && key != "note" && key != "list") {
                                        return (react_1.default.createElement(core_1.TableRow, { key: key },
                                            react_1.default.createElement(TableCell, { component: "th", scope: "row" }, key),
                                            react_1.default.createElement(TableCell, { align: "left" }, props.info[key])));
                                    }
                                })))),
                        react_1.default.createElement(DialogContent, null,
                            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", gutterBottom: true }, props.info.note)))));
            case 4:
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(Dialog_1.default, { onClose: props.onClose, "aria-labelledby": "customized-dialog-title", open: props.open },
                        react_1.default.createElement(DialogTitle, { id: "customized-dialog-title", onClose: props.onClose }, props.info.title),
                        react_1.default.createElement(DialogContent, { dividers: true },
                            react_1.default.createElement("ul", null, props.info.list.map(function (content, index) {
                                return (react_1.default.createElement("li", { key: index },
                                    " ",
                                    react_1.default.createElement(Typography_1.default, { display: "block", gutterBottom: true }, content)));
                            }))))));
            default:
                return null;
        }
    })()));
};
exports.default = ProductDetail;
